"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const utils_1 = require("../../utils");
const StyledTableContainer = (0, material_1.styled)(material_1.TableContainer)({
    overflow: "hidden",
});
const TableCellTitle = (0, material_1.styled)(material_1.TableCell)({
    borderBottom: "none",
    textAlign: "center",
    padding: 0,
});
const TableCellData = (0, material_1.styled)(material_1.TableCell)({
    borderBottom: "none",
    textAlign: "center",
    fontWeight: 700,
    padding: 0,
    color: "rgba(0, 0, 0, 0.60)",
});
const Text = (0, material_1.styled)(material_1.ListItemText)({
    fontSize: 12,
});
const LastLoadDateTable = ({ lastUpdatedDate, lastUpdatedMmrDate, lastUpdatedMorDate, state, currentYear, }) => {
    const [fiscalYear, setFiscalYear] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        // NOTE: currentYear intervals for THP are currently only year based,
        // e.g. 2019/2020 In order to display a fiscal year we need to set the
        // desired start and end month and day appropriately. Once the current
        // year values from the database contain full date values the set step
        // can be removed.
        if (state && currentYear)
            setFiscalYear((0, utils_1.calculateFiscalYear)(currentYear.toString()));
    }, [state, currentYear]);
    return (react_1.default.createElement(StyledTableContainer, null,
        react_1.default.createElement(material_1.Table, null,
            react_1.default.createElement(material_1.TableBody, null, [
                { title: "Last Data Load:", date: lastUpdatedDate },
                { title: "MMR:", date: lastUpdatedMmrDate },
                { title: "MOR:", date: lastUpdatedMorDate },
                { title: "Fiscal Year:", date: fiscalYear },
            ]
                .filter(({ date }) => !!date)
                .map(({ title, date }) => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.TableRow, null,
                    react_1.default.createElement(TableCellTitle, null,
                        react_1.default.createElement(Text, { primary: title, disableTypography: true }))),
                react_1.default.createElement(material_1.TableRow, null,
                    react_1.default.createElement(TableCellData, null,
                        react_1.default.createElement(Text, { primary: date, disableTypography: true }))))))))));
};
exports.default = LastLoadDateTable;
